(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('JobTitleDetailController', JobTitleDetailController);

    JobTitleDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'JobTitle'];

    function JobTitleDetailController($scope, $rootScope, $stateParams, entity, JobTitle) {
        var vm = this;

        vm.jobTitle = entity;

        var unsubscribe = $rootScope.$on('valueconnectApp:jobTitleUpdate', function(event, result) {
            vm.jobTitle = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
